// states/regionState.js

import { atom } from "recoil";

export const regionState = atom({
    key: "regionData", // unique ID (with respect to other atoms/selectors)
    default: [], // default empty array
});
